module.exports = __webpack_public_path__ + "img/Kolsass.95192bf4.jpg";